import { html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'

const i18n = {
  discard: () => t('discard', { ns: 'csc-rma-discard-button', default: 'Cancel return request' }),
}

export const RMA_DISCARD_REQUESTED = 'csc-rma-discard-requested'

@customElement('csc-rma-discard-button')
export class CSCRmaDiscardButton extends LitElement {
  protected override createRenderRoot = () => this

  private onClick() {
    this.dispatchEvent(new CustomEvent(RMA_DISCARD_REQUESTED, { bubbles: true, composed: true }))
  }

  override render() {
    return html`
      <cse-button variant="default" @click="${() => this.onClick()}"> ${i18n.discard()} </cse-button>
    `
  }
}
